import React from 'react';
import './landingPage.css';
import logo from '../../images/2.jpg';
import acccess from '../../images/feature1.jpg';
import f2 from '../../images/feature2.jpg';
import f3 from '../../images/feature3.jpg';
import f4 from '../../images/management.jpg';
import f5 from '../../images/online-booking.jpg';
import f6 from '../../images/online-sign-up.jpg';
import f7 from '../../images/mobile.jpg';
import f8 from '../../images/automation.jpg';
import f9 from '../../images/3.jpg';
import f10 from '../../images/truely_mobile.jpg';
import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();

  return (
    <>
      {/* Hero Section */}
      <div className="home-image flex items-center justify-end h-[400px] md:h-[700px] -mt-[100px] px-0 md:px-[0px] bg-none md:bg-cover">
  <div className="headerBox flex flex-col items-center md:items-end text-right p-4 md:p-10 max-w-[90%] md:max-w-[50%] bg-black/80 md:bg-transparent rounded-lg md:rounded-none">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight">
      Ultimate Gym Management Solution
    </h2>
    <p className="mt-4 text-sm sm:text-base md:text-lg text-white">
      <span className="font-bold">GymXS</span> is for gym owners like you. You want to streamline your business with powerful membership software that minimizes hassle, increases member retention, and helps both you and your members to achieve your goals.
    </p>
    <div className="mt-6 text-center w-full flex gap-4 justify-center">
            <button
              className="bg-[#F7931E] text-white font-medium px-6 py-2 rounded-lg hover:bg-[#e68217] transition-colors"
              onClick={() => navigate('/signup')}
            >
              SIGN UP NOW
            </button>
            <button
              className="bg-[#F7931E] text-white font-medium px-6 py-2 rounded-lg hover:bg-[#e68217] transition-colors"
              onClick={() => navigate('/login')}
            >
              SIGN IN
            </button>
            
    </div>
  </div>
</div>



      {/* Part 2 */}
      <div className='flex flex-col md:flex-row bg-lightGray py-10'>
        <div className='w-full md:w-1/2 p-4 md:p-10'>
          <img src={logo} alt='Gym Logo' className='w-full h-auto' />
        </div>
        <div className='w-full md:w-1/2 p-4 md:p-10'>
          <h3 className='text-[#DA4425] text-2xl md:text-3xl font-bold'>
            GymXS is a convenient gym and health club management solution
          </h3>
          <p className='mt-4 text-sm md:text-base'>
            GymXS is designed to make it easy to maintain detailed records of your members and their memberships, manage gym assets and staff, process and track sales. Designed to fit clubs of all sizes, this gym management solution is feature-rich.
          </p>
        </div>
      </div>

      {/* Part 3 */}
      <div className='container2 p-4 md:p-10 grid grid-cols-1 md:grid-cols-2 gap-4'>
        <div className='flex flex-col justify-center space-y-4 p-4 md:p-10'>
          <h2 className='text-[#DA4425] text-2xl md:text-3xl font-bold'>
            24/7 Gym Access Control
          </h2>
          <h3 className='text-[#5787C1] text-lg md:text-xl'>
            Whether you want a quick 24/7 solution or complete control over member movement within your facility, GymXS has the answer.
          </h3>
          <p className='text-sm md:text-base'>
            GymXS’s Access Control System provides an easy-to-implement and convenient way for members to access your facility, giving you added security and peace of mind.
          </p>
          <div className='mt-4 flex gap-4'>
            <button
              className='bg-[#F7931E] text-white px-4 py-2 rounded-lg'
              onClick={() => navigate('/signup')}
            >
              SIGN UP NOW
            </button>
            <button
              className='bg-[#F7931E] text-white px-4 py-2 rounded-lg'
              onClick={() => navigate('/login')}
            >
              SIGN IN
            </button>
          </div>
        </div>
      </div>

      {/* Part 4 */}
      <div className='bg-gray-200 p-4 md:p-10'>
        <div className='w-full md:w-4/5 mx-auto'>
          <h2 className='text-[#D73925] text-2xl md:text-3xl font-bold text-center'>
            Why GymXS is the best solution
          </h2>
          <div className='flex flex-col md:flex-row gap-4 mt-6'>
            <div className='w-full md:w-1/2'>
              <ul className='space-y-2'>
                <li className='flex items-center'>
                  <i className='fa fa-check text-green-900 mr-2'></i>
                  Manage your Operation more Efficiently
                </li>
                <li className='flex items-center'>
                  <i className='fa fa-check text-green-900 mr-2'></i>
                  Easier Customer Acquisition
                </li>
                <li className='flex items-center'>
                  <i className='fa fa-check text-green-900 mr-2'></i>
                  Reduce Management Administration
                </li>
              </ul>
            </div>
            <div className='w-full md:w-1/2'>
              <ul className='space-y-2'>
                <li className='flex items-center'>
                  <i className='fa fa-check text-green-900 mr-2'></i>
                  Improve Cash Flow
                </li>
                <li className='flex items-center'>
                  <i className='fa fa-check text-green-900 mr-2'></i>
                  Increase Retention
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Part 5 */}
      <div className='bg-gray-200 p-4 md:p-10'>
        <h2 className='text-[#D73925] text-2xl md:text-3xl font-bold text-center'>
          Features You'll Love
        </h2>
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-6'>
          {[
            { img: acccess, title: '24/7 Access Control', text: 'Open your gym for longer with confidence, saving time and money with GymXS’s advanced access control system.' },
            { img: f2, title: 'Integrated Billing', text: 'Get paid on time without the administrative stress with GymXS’s automated payment processing.' },
            { img: f3, title: 'Point of Sale', text: 'Boost your bottom line with a smart POS & tracking system that works on any device.' },
            { img: f4, title: 'Member Management', text: 'Deliver an exceptional member experience from the beginning. Go paperless with online signups, website integration, and a member dashboard that you’ll love.' },
            { img: f5, title: 'Online Booking', text: 'Give your members the flexibility to make online bookings for classes and PT sessions - wherever, whenever.' },
            { img: f6, title: 'Online Sign Up', text: 'Automate your sign-up process and increase your membership numbers with seamless website integration.' },
            { img: f7, title: 'Go Mobile', text: 'Free yourself from the front desk and experience the benefits of having your entire gym system at your fingertips.' },
            { img: f8, title: 'Automation', text: 'Marketing and member retention tools that you can simply set and forget.' },
          ].map((feature, index) => (
            <div key={index} className='flex flex-col items-center text-center p-4 bg-white rounded-lg shadow'>
              <img src={feature.img} alt={feature.title} className='w-16 h-16 mb-4' />
              <h3 className='text-[#D73925] text-lg font-bold'>{feature.title}</h3>
              <p className='text-sm mt-2'>{feature.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Part 6 */}
      <div className='flex flex-col md:flex-row p-4 md:p-10'>
        <div className='w-full md:w-1/2 p-4'>
          <img src={f9} alt='Touch Point Of Sale' className='w-full h-auto rounded-lg' />
        </div>
        <div className='w-full md:w-1/2 p-4 flex flex-col justify-center'>
          <h2 className='text-[#D73925] text-2xl md:text-3xl font-bold'>
            Touch Point Of Sale
          </h2>
          <h3 className='text-[#467ABD] text-lg md:text-xl mt-2'>
            Making transactions quick and easy for staff and customers with the user-friendly touch screen interface.
          </h3>
          <p className='text-sm md:text-base mt-4'>
            Set up and manage products with ease. Making sales and creating chargeable accounts for members with varying quantities and discounts is now easier than ever.
          </p>
          <div className='mt-6'>
            <button
              className='bg-[#F7931E] text-white px-4 py-2 rounded-lg'
              onClick={() => navigate('/signup')}
            >
              SIGN UP NOW
            </button>
          </div>
        </div>
      </div>

      {/* Part 7 */}
      <div className='flex flex-col md:flex-row bg-gray-200 p-4 md:p-10'>
        <div className='w-full md:w-1/2 p-4'>
          <h2 className='text-[#D73925] text-2xl md:text-3xl font-bold'>
            Freedom from your Desk
          </h2>
          <h3 className='text-[#467ABD] text-lg md:text-xl mt-2'>
            The mobile version of GymXS allows you to work from anywhere, any time.
          </h3>
          <p className='text-sm md:text-base mt-4'>
            The mobile version of GymXS allows you to work from anywhere, any time.
          </p>
        </div>
        <div className='w-full md:w-1/2 p-4'>
          <img src={f10} alt='Mobile Version' className='w-full h-auto rounded-lg' />
        </div>
      </div>

      {/* Part 8 */}
      <div className='flex items-center justify-center p-4 md:p-10 bg-gray-100'>
        <div className='bg-white bg-opacity-70 p-6 md:p-10 rounded-lg shadow-lg max-w-xl'>
          <h2 className='text-[#DA4425] text-2xl md:text-3xl font-bold mb-4'>
            Integrated Billing
          </h2>
          <p className='text-[#5787C1] text-sm md:text-base mb-2'>
            Let GymXS help you manage member's accounts with invoicing, billing integration, and credit card payments.
          </p>
          <p className='text-sm md:text-base'>
            Whether you want to automate your billing and reduce admin costs, or you are looking for a more hands-on solution, GymXS gives you flexibility and control over your payments process.
          </p>
        </div>
      </div>
    </>
  );
}

export default Home;